<ng-container *ngIf="vm$ | async as vm">
  <div
    *ngIf="vm.message && vm.color"
    class="notification row w-100"
    [class.red]="vm.color === NotificationColor.RED"
    [class.green]="vm.color === NotificationColor.GREEN"
  >
    <div *ngIf="vm.color === NotificationColor.GREEN" class="col-2">
      <svg-icon key="check" size="md"></svg-icon>
    </div>
    <div *ngIf="vm.color === NotificationColor.RED" class="col-2">
      <svg-icon key="warning" size="md"></svg-icon>
    </div>
    <div class="col-20">
      {{ vm.message }}
    </div>
    <div class="col-2 d-flex justify-content-end">
      <svg-icon key="cancel" size="md" class="cancel-icon" (click)="onCancelClick()"></svg-icon>
    </div>
  </div>
</ng-container>
